import bwipjs from 'bwip-js';
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';

import { ArrowsHorizontalIcon, Button, Heading, Pane, WarningSignIcon } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import Request from '../../../util/Api';
import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { getStockAccounts } from '../../stockAccount/actions/StockAccountActions';
import { deleteProduct, duplicateProduct, getProduct } from '../actions/ProductActions';
import ProductInfoBlock from '../components/ProductInfoBlock';
import TransferModal from '../components/TransferModal/TransferModal';

class ViewProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            transferModalOpen: false
        }

        this.id = this.props.params.id;

        this.closeTransferModal = this.closeTransferModal.bind(this);
        this.updateTransferModal = this.updateTransferModal.bind(this);
    }

    closeTransferModal = () => {
        this.setState({ transferModalOpen: false });
    }

    updateTransferModal = () => {
        this.getOutstandingTransfer();
    }

    async componentDidMount() {
        this.props.dispatch(getStockAccounts())
        await this.props.dispatch(getProduct(this.id))
        await this.getOutstandingTransfer()
        this.renderBarcode()
    }

    componentDidUpdate(prevProps) {
        const prev = prevProps.product && prevProps.product.barcode;
        const curr = this.props.product && this.props.product.barcode;
        if (curr && curr !== prev) this.renderBarcode();
    }

    renderBarcode = () => {
        const product = this.props.product;
        if (!product || !product.barcode) return;
        try {
            const canvas = document.getElementById(`barcode-product-${product.id}`);
            if (canvas) {
                bwipjs.toCanvas(canvas, {
                    bcid: 'code128',
                    text: product.barcode.toString(),
                    scale: 2,
                    height: 10,
                    includetext: true,
                    textxalign: 'center'
                });
            }
        } catch (error) {
            console.error('Error generating barcode:', error);
        }
    }

    handleDelete = () => {
        this.props.dispatch(deleteProduct(this.props.product.id));
    }

     handleDuplicate = () => {
        this.props.dispatch(duplicateProduct(this.props.product.id));
    }

    async getOutstandingTransfer() {
        const transfer = await Request.get(`/inventory/outstanding-transfer`);

        if(transfer.existing && transfer.existing.items) {
            const productItems = transfer.existing.items.filter(item => item.productId === this.props.product.id);
            this.setState({
                outstandingTransfer: productItems.map(item => ({
                    quantity: item.quantity,
                    stockAccountId: item.stockAccountId
                }))
            });
        }
    }

    render() {
        if(_.isEmpty(this.props.product)) {
            return <></>
        }
        return (
            <Pane padding={16} paddingTop={0}>
                 <TransferModal
                    product={this.props.product}
                    outstanding={this.state.outstandingTransfer}
                    stockAccounts={this.props.stockAccounts}
                    open={this.state.transferModalOpen}
                    onUpdate={this.updateTransferModal}
                    onClose={this.closeTransferModal}
                />

                <Pane display="flex">
                    <Pane>
                        <Link to="/products">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista produse
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge produsul"
                            title="Confirmare stergere produs"
                            confirmLabel="Sterg definitiv produsul"
                            message="Esti sigur ca vrei sa stergi produsul?"/>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDuplicate}
                            buttonLabel="Duplica produsul"
                            title="Confirmare duplicare produs"
                            confirmLabel="Creez un produs nou duplicat?"
                            message="Esti sigur ca vrei sa duplici produsul?"/>
                    </Pane>

                    <Button marginLeft={16} onClick={() => this.setState({ transferModalOpen: true })}>
                        <ArrowsHorizontalIcon />
                    </Button>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}
                    display="flex" alignItems="center" justifyContent="space-between">
                    <Heading size={600}>
                        Produs - <strong>{this.props.product.title}</strong>
                        {this.props.product.notifications.length > 0 ? <WarningSignIcon color="warning" marginRight={16}/> : null}
                    </Heading>
                    {this.props.product.barcode ? (
                        <Pane background="white" padding={4} borderRadius={4} marginLeft={16}>
                            <canvas id={`barcode-product-${this.props.product.id}`} />
                        </Pane>
                    ) : null}
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <ProductInfoBlock product={this.props.product}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        product: state.products.current,
        stockAccounts: state.stockAccounts.data
    }
}

export default connect(mapStateToProps)(ViewProduct);
